import { BaseService } from '@/core/base-service';

export default class AccessAuthorizationServiceService extends BaseService<any> {
	public constructor() {
		super('services/servicepze/api/admin/access-authorization/project');
	}
}
